import { Generic } from './Modal';
export function isModal(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isModal;    //# sourceMappingURL=isModal.js.map
